import orgApi from '@api/orgApi';
import ItemList from '@components/itemList';
import OrgTile from '@components/orgTile';
import useAuth from '@hooks/useAuth';
import { useTranslator } from '@i18n';
import { IconBinaryTree } from '@tabler/icons-react';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/profile/orgs/')({
  component: OrgsList,
});

function OrgsList() {
  const { hasClaim } = useAuth();
  const t = useTranslator();

  return (
    <ItemList
      domain="orgs"
      icon={<IconBinaryTree />}
      // Only global admins create and delete organizations. Groups are managed inside their organization.
      readonly={!hasClaim('orgs/create', 'global')}
      api={orgApi}
      backButton={{ to: '/profile' }}
      title={t('orgs.title')}
      // Groups are managed inside their organization, not listed alongside them
      listQuery={{ orgType: ['global', 'tenant'] }}
      renderItem={(org) => <OrgTile org={org} />}
      availableFilters={['createdOn']}
    />
  );
}
